<template>
  <div class="v-container page-menu">
    <div class="v-page-header">账号管理</div>
    <div class="v-header">
      <el-button type="primary" size="small" @click="add">
        <i class="el-icon-plus"></i>
        添加账号
      </el-button>
      <div>
        <el-cascader
          v-model="regionData"
          placeholder="地域筛选"
          size="mini"
          :props="{
            value: 'id',
            label: 'name',
            children: 'child',
            checkStrictly: true,
            expandTrigger: 'hover',
          }"
          :options="regionList"
          filterable
          style="width: 200px; margin-right: 5px"
        ></el-cascader>
        <el-input v-model="keyword" class="v-form-item" size="mini" placeholder="请输入账号" style="width: 200px"></el-input>
        <el-button class="v-ml-5" type="primary" size="mini" @click="getList(1)">搜索</el-button>
        <el-button size="mini" @click="reset">重置</el-button>
      </div>
    </div>
    <div class="v-content" v-loading="loading">
      <el-table :data="lists" border size="small" style="width: 100%">
        <el-table-column prop="nickname" label="昵称" width="160" />
        <el-table-column prop="login_name" label="账号" width="160" />
        <el-table-column prop="region_str" label="系统权限">
          <template slot-scope="scope">
            <div v-for="item in scope.row.area_data">
              <span>【{{ item.shop_name }}</span>
              <span>-{{ item.level == 1 ? '县级' : item.level == 2 ? '镇级' : '村级' }}</span>
              <span>-{{ item.user_type == 1 ? '观察者' : '运营方' }}】</span>
              <span>{{ item.area.map((item) => item.name).join('-') }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1" class="v-color-green">启用</span>
            <span v-if="scope.row.status == 2" class="v-color-red">禁用</span>
          </template>
        </el-table-column>
        /Users/guopeng/workspace/vyb/vyb_yy/vyb_yy_front/admin/src/pages/login/login.vue
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)" type="default" size="min" icon="el-icon-edit"></el-button>
            <el-button @click="del(scope.row)" :loading="scope.row.loading" type="default" size="min" icon="el-icon-delete"></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="v-footer">
      <el-pagination
        layout="total,sizes,prev, pager, next"
        @size-change="
          (page_size) => {
            getList(page, page_size);
          }
        "
        @current-change="
          (page) => {
            getList(page);
          }
        "
        :current-page.sync="page"
        :total="total"
      ></el-pagination>
    </div>
    <AccountAddEdit v-if="isShowAddEdit" :isShow.sync="isShowAddEdit" @success="getList" :row="row" :addEditType="addEditType" />
  </div>
</template>

<script>
import AccountAddEdit from './components/account-add-edit';

export default {
  components: {
    AccountAddEdit,
  },
  data() {
    return {
      lists: [], // table数据
      isShowAddEdit: false, // 显示新增修改弹窗
      isShowPermission: false, // 显示设置角色
      loading: false, // 页面loading
      addEditType: 1, // 1添加 2修改 3添加子类
      row: null, // 操作时row
      userInfo: this.$store.getters.userInfo,
      page: 1,
      page_size: 10,
      total: 0,
      keyword: '',
      config: this.config,
      regionList: [],
      regionData: [],
    };
  },
  created() {
    this.getList();
    this.getRegionList();
  },
  methods: {
    // 获取列表
    async getList(page, page_size) {
      this.loading = true;
      this.page = page ? page : this.page;
      this.page_size = page_size ? page_size : this.page_size;
      try {
        let res = await this.api.user.getAdmin({
          page: this.page,
          page_size: this.page_size,
          keyword: this.keyword,
          area_id: this.regionData.length ? this.regionData[this.regionData.length - 1] : '',
        });
        this.lists = res.data.data;
        this.total = res.data.total;
      } catch (ex) {
        console.error(ex);
      }
      this.loading = false;
    },

    reset() {
      this.regionData = [];
      this.keyword = '';
      this.getList(1);
    },

    async getRegionList() {
      try {
        this.regionList = await this.$store.dispatch('user/getAreaList');
      } catch (e) {
        console.error(e);
      }
    },

    // 添加
    add() {
      this.row = null;
      this.isShowAddEdit = true;
      this.addEditType = 1;
    },
    // 修改
    edit(row) {
      this.addEditType = 2;
      this.row = row;
      this.isShowAddEdit = true;
    },
    // 删除
    async del(row) {
      try {
        await this.$confirm('确认删除么?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' });
        this.$set(row, 'loading', true);
        let res = await this.api.user.deleteAdmin({ id: row.id });
        this.$message.success(res.message);
        this.getList();
      } catch (e) {
        console.error(e);
      }
      this.$set(row, 'loading', false);
    },
  },
};
</script>

<style lang="scss" scoped>
.tool-bar {
  padding: 0 0 15px 0;
}
.v-header {
  display: flex;
  justify-content: space-between;
}
</style>
